import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base.service';
import { Rendicion } from 'src/app/models/tesoreria/rendicion.model';

@Injectable({
  providedIn: 'root'
})
export class RendicionService extends BaseService {

    recordName = 'rendiciones';

    url = `${ environment.host }/rendicion`;

    codigoModulo = Rendicion.CODIGO_MODULO;
    codigoRegistro = Rendicion.CODIGO_REGISTRO;
}
